// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1_P2y","cls2":"Header-cls2_bFh Header-cls1_P2y"};